import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch {
      toast.error("Errore, riprova");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-10">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-card border border-border rounded-2xl p-7 shadow-sm">
        {!sent ? (
          <>
            <span className="grid place-items-center w-11 h-11 rounded-xl bg-accent text-accent-foreground mb-4">
              <EnvelopeSimple size={22} weight="duotone" />
            </span>
            <h1 className="font-heading text-2xl font-bold">Password dimenticata?</h1>
            <p className="text-muted-foreground text-sm mt-1">Inserisci la tua email: ti invieremo un link per reimpostarla.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" className="mt-1.5" />
              </div>
              <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="forgot-submit">
                {loading ? "Invio…" : "Invia link di reset"}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="forgot-sent">
            <CheckCircle size={52} weight="fill" className="mx-auto text-emerald-500" />
            <h1 className="font-heading text-xl font-bold mt-3">Controlla la tua email</h1>
            <p className="text-muted-foreground text-sm mt-2">Se esiste un account con <b>{email}</b>, riceverai un link per reimpostare la password (valido 1 ora).</p>
          </div>
        )}
        <p className="text-sm text-center text-muted-foreground mt-6">
          <Link to="/login" className="text-primary font-medium" data-testid="back-to-login">Torna all'accesso</Link>
        </p>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;
